import React, { useState, useEffect } from 'react';
import { apiClient } from '../config/api';
import './UserModal.css';

const PlanUsersModal = ({ plan, onClose }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, [plan]);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Fetch all users (may need pagination)
      let allUsers = [];
      let page = 1;
      let hasMore = true;
      
      while (hasMore) {
        try {
          const response = await apiClient.get(
            `/admin/users?page=${page}&page_size=100`,
            token
          );
          // Handle response structure: { status: true, data: { users: [...], total: 18, page: 1, page_size: 20 } }
          const usersData = response.data?.users || (Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : []));
          if (Array.isArray(usersData) && usersData.length > 0) {
            allUsers = [...allUsers, ...usersData];
            page++;
            if (usersData.length < 100) {
              hasMore = false;
            }
          } else {
            hasMore = false;
          }
        } catch (error) {
          console.error('Error fetching users page:', error);
          hasMore = false;
        }
      }
      
      // Filter users by plan name from plan_details
      let filteredUsers = [];
      if (plan.name === 'Free plans') {
        filteredUsers = allUsers.filter(user => {
          const planName = user.plan_details?.current?.plan?.name || '';
          return planName && planName.toLowerCase().includes('free');
        });
      } else if (plan.name === 'Loved one Plans') {
        filteredUsers = allUsers.filter(user => {
          const planName = user.plan_details?.current?.plan?.name || '';
          return planName && (planName.toLowerCase().includes('loved') || planName.toLowerCase().includes('personal'));
        });
      } else {
        filteredUsers = allUsers.filter(user => {
          const planName = user.plan_details?.current?.plan?.name || '';
          return planName === plan.name;
        });
      }
      setUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
      alert('Failed to fetch users: ' + (error.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content plan-users-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Users with "{plan.name}" Plan</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="plan-users-content">
          {loading ? (
            <div className="loading">Loading users...</div>
          ) : users.length === 0 ? (
            <div className="no-users">No users found with this plan</div>
          ) : (
            <table className="plan-users-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Date Created</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id || user.user_id}>
                    <td>{user.email}</td>
                    <td>{formatDate(user.created_at || user.date_created)}</td>
                    <td>
                      <span className={`status-badge ${user.status || 'active'}`}>
                        {user.status || 'active'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="modal-actions">
          <button type="button" className="cancel-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanUsersModal;



